import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline, secondaryFill, secondaryOutline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M23.2402 41.87C23.2402 41.87 50.8702 27.42 52.2702 25.66C53.6702 23.9 54.6102 1 54.6102 1H76.6202C76.6202 1 77.5602 23.9 78.9602 25.66C80.3602 27.42 107.99 41.87 107.99 41.87C107.99 41.87 95.7402 56.92 65.6102 56.92C35.4802 56.92 23.2402 41.87 23.2402 41.87Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M9.52002 47.5599C12.6 43.9299 46.2 27.6399 46.2 27.6399C46.2 27.6399 48.79 33.6399 58.64 37.1599C64.03 39.0899 65.91 41.5099 65.91 41.5099C65.91 41.5099 66.65 40.5299 68.55 39.1399C69.85 38.1899 71.51 37.4799 73.76 36.6699C81.64 33.8699 85.39 27.9099 85.39 27.9099C85.39 27.9099 118.63 43.9299 121.71 47.5599C124.79 51.1899 129.23 73.5399 129.23 73.5399H2C2 73.5399 6.44002 51.1999 9.52002 47.5599Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M65.5699 67.24C66.2492 67.24 66.7999 66.6893 66.7999 66.01C66.7999 65.3307 66.2492 64.78 65.5699 64.78C64.8905 64.78 64.3398 65.3307 64.3398 66.01C64.3398 66.6893 64.8905 67.24 65.5699 67.24Z"
        fill={outline}
      />
      <path
        d="M65.5699 58.3499C66.2492 58.3499 66.7999 57.7992 66.7999 57.1199C66.7999 56.4406 66.2492 55.8899 65.5699 55.8899C64.8905 55.8899 64.3398 56.4406 64.3398 57.1199C64.3398 57.7992 64.8905 58.3499 65.5699 58.3499Z"
        fill={outline}
      />
      <path
        d="M65.5699 49.46C66.2492 49.46 66.7999 48.9093 66.7999 48.23C66.7999 47.5507 66.2492 47 65.5699 47C64.8905 47 64.3398 47.5507 64.3398 48.23C64.3398 48.9093 64.8905 49.46 65.5699 49.46Z"
        fill={outline}
      />
      <path
        d="M90.3699 30.8601C90.3699 30.8601 87.3099 36.3901 80.6299 39.6901C73.9499 42.9901 68.9099 43.4101 68.9099 54.1401C68.9099 64.8701 68.9099 70.8201 68.9099 70.8201H62.2999C62.2999 70.8201 62.2999 64.8701 62.2999 54.1401C62.2999 43.4101 57.2599 42.9901 50.5799 39.6901C43.8899 36.3901 40.8398 30.8601 40.8398 30.8601"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M68.9902 52.3299C68.9902 52.3299 69.0702 41.6799 59.9902 38.3799"
        stroke={outline}
        fill="none"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M32.5801 61.98H98.6501L101.35 73.55H29.8701L32.5801 61.98Z"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M91.1008 62.5601C91.1008 62.5601 90.0208 64.1201 90.4308 64.9001C90.8408 65.6801 92.0708 65.49 92.4708 65.98C92.8708 66.47 91.9508 67.75 93.0808 68.35C94.2108 68.95 94.7508 67.4701 95.3808 67.5301C96.0108 67.5901 96.4908 68.67 97.3608 68.58C98.2308 68.49 98.9808 66.7501 98.9808 66.7501L91.1008 62.5601Z"
        stroke="white"
        fill="none"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M91.3506 63.3101L98.2006 66.9501L112.451 40.2301L105.591 36.5901L91.3506 63.3101Z"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M97.2108 50.3642L105.671 54.8582L107.89 50.6811L99.4297 46.1871L97.2108 50.3642Z"
        stroke="white"
        fill="none"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M93.6411 69.2501C94.7347 69.2501 95.6212 68.3636 95.6212 67.2701C95.6212 66.1765 94.7347 65.29 93.6411 65.29C92.5476 65.29 91.6611 66.1765 91.6611 67.2701C91.6611 68.3636 92.5476 69.2501 93.6411 69.2501Z"
        fill="white"
      />
      <path
        d="M40.1202 62.5601C40.1202 62.5601 41.2002 64.1201 40.7902 64.9001C40.3802 65.6801 39.1502 65.49 38.7502 65.98C38.3502 66.47 39.2702 67.75 38.1402 68.35C37.0102 68.95 36.4702 67.4701 35.8402 67.5301C35.2102 67.5901 34.7302 68.67 33.8602 68.58C32.9902 68.49 32.2402 66.7501 32.2402 66.7501L40.1202 62.5601Z"
        stroke="white"
        fill="none"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M39.8803 63.3101L33.0203 66.9501L18.7803 40.2301L25.6303 36.5901L39.8803 63.3101Z"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M31.7794 46.1606L23.3193 50.6545L25.5382 54.8316L33.9983 50.3376L31.7794 46.1606Z"
        stroke="white"
        fill="none"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M37.5806 69.2501C38.6741 69.2501 39.5606 68.3636 39.5606 67.2701C39.5606 66.1765 38.6741 65.29 37.5806 65.29C36.4871 65.29 35.6006 66.1765 35.6006 67.2701C35.6006 68.3636 36.4871 69.2501 37.5806 69.2501Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="65.6117"
          y1="33.1882"
          x2="65.6117"
          y2="22.8846"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
